export default {
  estaCarregando: false,
  lista: [],
  parametros: '',
  filtros: {
 
  }
}
